// src/features/imports/model/imports.toSubmit.ts

import type { ImportedFileLogsSubmitDto } from './imports.submit.dto'
import type { ImportsFeatureState } from './imports.state.types'
import type {
  ImportedFileDriverInfoSubmitDto,
  ImportedFileVehicleInfoSubmitDto,
} from './imports.submit.dto'
import {
  ImportedFileDriverInfo,
  ImportedFileLogs,
  ImportedFileVehicleInfo,
} from '@/app/models/import/uploadedFileModel'
import { FileType } from '@/app/constants/fileType'

/**
 * Backend zapisuje jako aktywne tylko to, co przyjdzie w existing*,
 * więc zaznaczone pozycje idą tam niezależnie od tego, czy są nowe.
 */
export function buildSubmitImportsRequest(
  state: ImportsFeatureState,
  visibleVehicleIds?: Set<string>,
): ImportedFileLogsSubmitDto {
  const logs: ImportedFileLogsSubmitDto = {
    existingDrivers: [],
    ignoredDrivers: [],
    newDrivers: [],
    existingVehicles: [],
    ignoredVehicles: [],
    newVehicles: [],
  }

  for (const driver of Array.from(
    Object.values(state.readModel.driverItemsById),
  )) {
    const sourceFile = state.readModel.filesById[driver.fileId]
    // Absences are persisted in Process(), same as C#. Do not send them through
    // SaveImport as DDD existing/new drivers.
    if (sourceFile && Number(sourceFile.fileType) === FileType.Absences) {
      continue
    }
    const isSelected = state.ui.selectedDriverImportIds.has(driver.id)
    const assigned = driver.id in state.ui.driverAssignedToByImportId && state.ui.driverAssignedToByImportId[driver.id] ?  state.ui.driverAssignedToByImportId[driver.id] : undefined
    const cooperationStartDate = driver.id in state.ui.driverDateFromByImportId ? state.ui.driverDateFromByImportId[driver.id] : undefined
    
    const log: ImportedFileDriverInfoSubmitDto = {
      fullName: driver.fullName,
      cardNumber: driver.cardNumber,
      daysRead: driver.daysRead,
      vehiclesUsed: [],
      cooperationStartDate,
      checked: isSelected,
      assignedTo: assigned ?? undefined
    }
    if (isSelected || driver.bucket === 'existing') {
      logs.existingDrivers.push(log)
    } else {
      // Niezaznaczony nowy kierowca zapisuje się jako nieaktywny, tak jak pojazd.
      logs.ignoredDrivers.push(log)
    }
  }

  for (const vehicle of Object.values(state.readModel.vehicleItemsById)) {
    const isSelected = state.ui.selectedVehicleImportIds.has(vehicle.id)
    const isVisible = !visibleVehicleIds || visibleVehicleIds.has(vehicle.id)
    const assigned = state.ui.vehicleAssignedToByImportId[vehicle.id]
    const log: ImportedFileVehicleInfoSubmitDto = {
      registrationNumber: vehicle.registrationNumber,
      daysRead: vehicle.daysRead,
      checked: isSelected,
      assignedTo: assigned ?? undefined,
    }

    if (isSelected) {
      logs.existingVehicles.push(log)
    } else if (isVisible) {
      logs.ignoredVehicles.push(log)
    }
  }

  return logs
}
